





















































import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import PdMonitorChart from "../../chart.vue";
import DynamicColumnSelect from "../../dynamicColumnSelect.vue";
import {
  QueryPdMonitorBalanceChartData,
  GetPdAssessBalanceListForMonitor
} from "@/api/pdOutPatient/pdComprehensiveEvaluation/pdAssessBalance";
@Component({
  components: {
    PdMonitorChart,
    DynamicColumnSelect
  }
})
export default class PdMonitorBalance extends AbpBase {
  @Prop() patient: any;
  currentType: string = "0";
  chartData: any = null;
  selectedColumns: any = [];
  data: any = [];
  showDyanmicColumnSelect: boolean = false;
  petButtons: any = [
    {
      type: "0",
      buttonText: "肌酐D/P",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "1",
      buttonText: "葡萄糖D/Do",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "2",
      buttonText: "净超滤量",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    }
  ];
  petGlButtons = [
    {
      type: "3",
      buttonText: "肌酐D/P",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "4",
      buttonText: "葡萄糖D/Do",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "5",
      buttonText: "钠D/P",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    },
    {
      type: "6",
      buttonText: "净超滤量",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    }
  ];

  columns = [
    {
      title: "肌酐D/P（0/2/4小时）",
      key: "dp",
      width: 200
    },
    {
      title: "葡萄糖D/Do（0/2/4小时）",
      key: "dDo",
      width: 230
    },
    {
      title: "净超滤量",
      key: "cll",
      width: 100
    },
    {
      title: "（改良）肌酐D/P（0/1/4小时）",
      key: "gL_DP",
      width: 260
    },
    {
      title: "（改良）葡萄糖D/Do（0/1/4小时）",
      key: "gL_DDo",
      width: 290
    },
    {
      title: "（改良）钠D/P（0/1/4小时）",
      key: "gL_Na",
      width: 250
    },
    {
      title: "（改良）净超滤量",
      key: "gL_CLL",
      width: 200
    }
  ];

  @Watch("patient", { immediate: true, deep: true })
  onPatientChanged() {
    this.selectedColumns = JSON.parse(JSON.stringify(this.columns)); //此处用数组拷贝的方式会出现错误“You may have an infinite update loop in watcher with expression "columns"”，故采用json序列化的方式拷贝数组，且render函数无效，需另外编写api数据接口
    this.insertAssessTime();
    if (this.patient.pD_Patient_ID) {
      this.handleClick("0");
      this.getData();
    }
  }

  //在第一列前面插入评估日期
  insertAssessTime() {
    this.selectedColumns.splice(0, 0, {
      title: "日期",
      key: "assessTime",
      minWidth: 120,
      render: (h: any, p: any) => {
        return h("div", {}, this.formatDate(p.row.assessTime));
      }
    });
  }

  async getData() {
    let res = await GetPdAssessBalanceListForMonitor(
      this.patient.pD_Patient_ID
    );
    this.data = res.objects;
  }

  async handleClick(type: string) {
    this.currentType = type;
    let payload = {
      pD_Patient_ID: this.patient.pD_Patient_ID,
      type: type
    };
    let res = await QueryPdMonitorBalanceChartData(payload);
    this.chartData = res.objects;
  }

  handleDyanmicColumnSelectOk() {
    let res = this.$refs.DynamicColumnSelect.onSubmit();
    this.selectedColumns = JSON.parse(JSON.stringify(res));
    this.insertAssessTime();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdMonitor/pdMonitorIndex/parts/pdMonitorBalance/index.vue